import { Pipe, PipeTransform } from "@angular/core";
import { Nullable } from "@models/nullable";
import { Interaction, InteractionType } from "@models/auxiliary-company-models";

@Pipe({
  name: "interactionIcon",
})
export class InteractionIconPipe implements PipeTransform {
  transform(interaction: Nullable<Interaction>): Nullable<string> {
    if (!interaction) return null;

    const iconMap: { [key: string]: number[] } = {
      "assets/svg/interation-email.svg": [3, 7], // Email or Outbound Email
      "assets/svg/interation-phone.svg": [2, 8], // Phone or LeftVoicemail
      "assets/svg/interation-coffe.svg": [1],    // Meeting
      "assets/svg/interation-video.svg": [4],    // VideoCall
      "assets/svg/interation-notes.svg": [0, 9, 10, 11, 12], // Notes, Bid, BreakIn, etc.
    };

    const iconEntry = Object.entries(iconMap).find(([_, types]) =>
      types.includes(interaction.interactionType)
    );

    return iconEntry ? iconEntry[0] : null;
  }
}


